import { Grid, Typography, Box } from '@mui/material';
import movil from '../../../../assets/manomov.png';

const Six = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '0 auto',
        marginTop:'2%',
        padding: { xs: '10px', md: '10px 250px' }, // Padding adaptado para móviles y ordenadores
        width: '100%', // Aseguramos que ocupe todo el ancho disponible
      }}
    >
      <Grid
        container
        spacing={{ xs: 3, md: 4 }} // Ajuste de espaciado en móviles y en desktop
        alignItems="center"
        justifyContent="center"
        sx={{
          marginTop: '2%',
          width: '100%', // Se asegura que el contenedor de los elementos ocupe todo el ancho
        }}
      >
        <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'center', md: 'left' }, padding: { xs: '20px', md: '0' } }}> 
          <Typography variant="h3" sx={{ fontSize: { xs: '1.5rem', md: '3rem' }, fontWeight: 'bold' }}>
            Informes de KPI detallados
          </Typography>
          <Typography variant="body2" sx={{ fontSize: { xs: '1rem', md: '1.5rem' }, mt: 2, fontWeight: 'bold' }}>
            Toma decisiones estratégicas con datos automáticos de rendimiento.
          </Typography>
          <Typography variant="body2" sx={{ fontSize: { xs: '1rem', md: '1.5rem' }, mt: 2 }}>
            Recibe informes precisos que te permiten optimizar la gestión de tus vehículos y realizar mantenimiento preventivo de manera oportuna.
          </Typography>
        </Grid>

        <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            width: '100%',
            height: 'auto',
            maxWidth: { xs: '400px', md: '500px' }, // Cambia el maxWidth dependiendo del tamaño de la pantalla
            marginRight:{md:'400px', xs:'50px'},
          }}
        >
          <img
            src={movil}
            alt="Descripción de la imagen"
            style={{
              width: '100%',
              height: 'auto',
            }}
          />
        </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Six;
